// extracted by mini-css-extract-plugin
export default {"m":"e2a65bbf9c","title":"_0a9dd912c7","feedback_inner_title":"_8b574e5b7e","textarea":"_6f02e8c4f3","radio":"_18317f37c5","text":"_9337f7ed7f"};